import API from "api/base/base";
import { axios } from "utils/axios";

const Views = new API({ controller: "views" });

Object.assign(Views, {
  createViews(payload) {
    return axios.post(`${this.url}`, payload);
  },
});

export default Views;
